<template>
  <div>
    <view-table
        ref="viewTable"
        :filter="filter"
        :limits="limits"
        :columns-property="columnsProperty"
        :table-select="false"
        module="basic"
        url="customerMaterialMappings/page"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <el-upload
            style="float: left"
            action=""
            :http-request="importFile"
            :disabled="importLoading"
            :show-file-list="false">
          <el-button v-if="limits.addAuth" style="margin-left: 10px" :loading="importLoading" type="primary">
            批量导入
          </el-button>
        </el-upload>
      </template>
      <template slot="adSearch">
        <el-form :model="filter" :inline="true" @keyup.enter.native="loadData(1)">
          <el-form-item label="客户编号">
            <el-input v-model.trim="filter.customerNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model.trim="filter.customerName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料规格">
            <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="客户物料编号">
            <el-input v-model.trim="filter.customerMaterialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="客户物料名称">
            <el-input v-model.trim="filter.customerMaterialName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="客户物料规格">
            <el-input v-model.trim="filter.customerMaterialSpec" placeholder="请输入" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
    <customer-material-mapping-edit ref="editPage" @save-success="loadData(1)"/>
  </div>
</template>
<script>
  import ViewTable from "@/components/ViewTable.vue";
  import CustomerMaterialMappingEdit from "@/views/information/CustomerMaterialMapping/CustomerMaterialMappingEdit";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "CustomerMaterialMappingList",
    components: {CustomerMaterialMappingEdit, ViewTable},
    data() {
      return {
        limits: {
          addAuth: this.$auth(107),
          editAuth: this.$auth(108),
          delAuth: this.$auth(109),
        },
        importLoading: false,
        filter: {
          customerNo: "",
          customerName: "",
          materialNo: "",
          materialName: "",
          specification: "",
          customerMaterialNo: "",
          customerMaterialName: "",
          customerMaterialSpec: "",
        },
        columnsProperty: [
          {
            key: "customerName",
            minWidth: 260,
          },
          {
            key: "customerMaterialName",
            minWidth: 400,
          },
          {
            key: "customerMaterialNo",
            width: 140,
          },
          {
            key: "customerMaterialSpecification",
            minWidth: 140,
          },
          {
            key: "materialNo",
            width: 160,
          },
          {
            key: "materialDesc",
            minWidth: 400,
          },
          {
            key: "creatorName",
            align: "center",
            width: 90,
          },
          {
            key: "updateTime",
            align: "center",
            width: 160,
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      // 查询客户物料关系列表
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 新建 编辑
      addEditHandle(row) {
        this.$refs.editPage.open(row);
      },

      // 删除
      deleteHandle(row) {
        this.$http.delete("basic", "customerMaterialMappings", row.pkid).then((res) => {
          if (res.success) {
            this.$message.success("删除成功");
            this.loadData();
          }
        });
      },
      //考勤时间导入
      importFile(params) {
        this.importLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "customerMaterialMappings/import", formData)
          .then((res) => {
            if (res.success) {
              this.$message.success("导入成功");
              this.loadData(1);
            }
            this.importLoading = false;
          })
          .catch(() => {
            this.importLoading = false;
          });
      },
      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
